import React, { useMemo } from "react";
import localization from "../../data/config";
import { useSelector } from "react-redux";
import { BREADCRUMB_URL, GENERIC_TOKEN } from "../../constants/config/parts";
import "./style.css";

/**
 * @name BreadCrumb
 * @function
 * @description Displays the Breadcrumb for PST Table
 * @returns {JSX}
 */
const BreadCrumb = () => {
  const breadCrumbUrl = useSelector((state) => state.app.breadCrumbUrl);

  /**
   * @name breadcrumbsWithHome
   * @function
   * @returns Memoized array of breadcrumbs with home, original breadcrumbs
   */
  const breadcrumbsWithHome = useMemo(() => {
    return [
      { name: localization.homeLabel, url: '/index.html' },
      ...breadCrumbUrl
    ];
  }, [breadCrumbUrl]);
  return (
    <div className="breadcrumb__container">
      <div className="pst__breadcrumb">
        <ul className="breadcrumb__nav">
          {breadcrumbsWithHome.map((breadcrumb, index) => (
            <li key={breadcrumb.url}>
              {index !== 0 && (
                <span className="breadcrumb__seperator"> / </span>
              )}
              <a
                className="breadcrumb__item__weblinksmall"
                href={BREADCRUMB_URL.replace(GENERIC_TOKEN, breadcrumb.url)}
                title={breadcrumb.name}
                dangerouslySetInnerHTML={{ __html: breadcrumb.name }}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BreadCrumb;
